import { enUS, ru, de } from 'date-fns/locale';

const locales = { en: enUS, ru, de };

export default locales;
